import { render, staticRenderFns } from "./faq-tab-loader.vue?vue&type=template&id=b862fdc6"
import script from "./faq-tab-loader.vue?vue&type=script&lang=js"
export * from "./faq-tab-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports